import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { languageType } from '../../util/languageType';
export const loadData = (params, search) => async dispatch => {
  let pageId = params.pageId;
  const basePageId = pageId;
  try {
    const language = languageType();
    pageId =
      language === 'el' ? `${pageId}-greek` : language === 'es' ? `${pageId}-spanish` : pageId;
    console.log('pageId', pageId);

    const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
    const hasFallbackContent = false;
    const res = await dispatch(fetchPageAssets(pageAsset, hasFallbackContent, pageId));
    if (!res && pageId !== basePageId) {
      const fallbackAsset = { [basePageId]: `content/pages/${basePageId}.json` };

      return dispatch(fetchPageAssets(fallbackAsset, hasFallbackContent, basePageId));
    }
    return res;
  } catch (e) {
    console.log('eeee', e);
  }
};
